import React, {Component} from 'react';
import Styles from './style.css';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
import SignupImage from "../../pages/signup-image/component";
import SignupQuotes from "../../pages/signup-quotes/component";
import SignupAds from "../../pages/signup-ads/component";
import SignupFilter from "../../pages/signup-filter/component";
import SignupCheckout from "../../pages/signup-checkout/component";
import SignupPayment from "../../pages/signup-payment/component";
import SignupConfirmation from "../../pages/signup-confirmation/component";
import Register from "../../pages/register/component";
import User from "../../pages/user/component"
import SignupBudget from "../../pages/signup-budget/component";
import ForgotPassword from "../../pages/forgotpassword/component";
import ResetPassword from "../../pages/resetpassword/component";
import {BeatLoader} from "react-spinners";
import {langRegister} from "../../services/langRegister";
import LoginNopin from "../../pages/login-nopin/component";
import {dataRegister} from "../../services/dataRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {cartRegister} from "../../services/cartRegister";
import {quotesRegister} from "../../services/quotesRegister";
import {imagesRegister} from "../../services/imagesRegister";
import ErrorHandler from "../error-handler/component";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from 'react-facebook-pixel';
import {tokenRegister} from "../../services/tokenRegister";
import {userRegister} from "../../services/userRegister";
import Token from "../../pages/token/component";
import SignupCrossroad from "../../pages/signup-crossroad/component";
import SignupHome from "../../pages/signup-home/component";
import SignupPaymentRedirect from "../../pages/signup-payment-redirect/signup-payment-redirect";
import SignupIndustry from "../../pages/signup-industry/component";
import SignupBusiness from "../../pages/signup-business/component";
import SignupQuotesDivided from "../../pages/signup-quotes-divided/component";
import SignUpTheme from "../../pages/signup-theme/component";
import SignUpThemeCustom from "../../pages/signup-theme-custom/component";
import SignupVideo from "../../pages/signup-video/component";
import SignupSlideshow from "../../pages/signup-slideshow/component";

import SCfaviconAppleTouch from '../../assets/saleschannel-favicon/apple-touch-icon.png';
import SCfavicon16 from '../../assets/saleschannel-favicon/favicon-16x16.png';
import SCfavicon32 from '../../assets/saleschannel-favicon/favicon-32x32.png';
import SCfaviconSiteManifest from '../../assets/saleschannel-favicon/site.webmanifest';
import SCfaviconSiteSafari from '../../assets/saleschannel-favicon/safari-pinned-tab.svg';

import ABfaviconAppleTouch from '../../assets/adbop-favicon/apple-touch-icon.png';
import ABfavicon16 from '../../assets/adbop-favicon/favicon-16x16.png';
import ABfavicon32 from '../../assets/adbop-favicon/favicon-32x32.png';
import ABfaviconSiteManifest from '../../assets/adbop-favicon/site.webmanifest';
import ABfaviconSiteSafari from '../../assets/adbop-favicon/safari-pinned-tab.svg';

import {Helmet} from 'react-helmet'

class RouterWrapper extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            error: false,
            market: null,
            lang: null
        }
    };

    componentWillMount() {
        this._setApiDomain();
    }

    componentWillReceiveProps(){
        this._setApiDomain();
    }

    _setApiDomain() {
        try {
            dataRegister.documentLocation().then((response) => {
                let environment = response.headers.get('APP_PRODUCTION');
                if (environment === "true") {
                    dataRegister.setApiDomain("primehit");
                    this._setDomain(window.location.href);
                } else if (environment === "local") {
                    dataRegister.setApiDomain(this._getHostingUrl(window.location.href));
                    this._setDomain(window.location.href);
                } else {
                    dataRegister.setApiDomain("devprimehit");
                    this._setDomain(window.location.href);
                }
            }, (error) => {
                dataRegister.setApiDomain("devprimehit");
                this._setDomain(window.location.href);
            });
        }catch (e) {
            this.setState({error: true, isLoading: false});
        }
    }

    _setDomain(url) {
        dataRegister.setDomain(this._getHostingUrl(url));
        this._setVariables();
    }

    _getHostingUrl(url) {
        try {
            url = url.replace("app.", '');
            console.log(url);
        }catch (e) {}
        var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
        if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
            return match[2];
        }
        else {
            return null;
        }
    }

    _setVariables() {

        const markets = {
            ae: {
                en: true,
                default: "en"
            },
            se: {
                sv: true,
                en: true,
                default: "sv"
            }
        };

        try {
            if (this.props.match.params.market && this.props.match.params.lang) {

                //CHECK IF LANG EXIST IN MARKET
                if(markets[this.props.match.params.market][this.props.match.params.lang]){

                    langRegister.set(this.props.match.params.lang);

                    this._updateData().then((response) => {
                        if (response) {

                            if(this.props.match.params.saleschannel){
                                salesChannelRegister.set("name", this.props.match.params.saleschannel);
                            }
                            if(this.props.match.params.market){
                                salesChannelRegister.set("market", this.props.match.params.market);
                            }
                            if(response.available_channel){
                                salesChannelRegister.set('available_channels', JSON.stringify(response.available_channel));
                            }else{
                                salesChannelRegister.set('available_channels', JSON.stringify({fb: true, google: true, bing: true, instagram: true}));
                            }
                            if (response.name) {
                                salesChannelRegister.set("company_name", response.name);
                                this._updateTitle(response.name);
                            }
                            if (response.stripe_public_key) {
                                salesChannelRegister.set("stripe_public_key", response.stripe_public_key);
                            }
                            if (response.logo) {
                                salesChannelRegister.set('logo', response.logo);
                            }
                            if (response.goal_off) {
                                salesChannelRegister.set('goal_off', response.goal_off);
                            }
                            if (response.social_targeting) {
                                salesChannelRegister.set('social_targeting', response.social_targeting);
                            }
                            if (response.private) {
                                salesChannelRegister.set('private', response.private);
                            }
                            if (response.logo_dashboard) {
                                salesChannelRegister.set('logo_dashboard', response.logo_dashboard);
                            }
                            if (response.logo_mobile) {
                                salesChannelRegister.set('logo_mobile', response.logo_mobile);
                            }
                            if(response.country_region){
                                salesChannelRegister.set('country_region', JSON.stringify(response.country_region));
                            }
                            if(response.default_language){
                                salesChannelRegister.set('default_language', response.default_language);
                            }
                            if(response.channels){
                                salesChannelRegister.set('channels', JSON.stringify(response.channels));
                            }
                            if (response.currency) {
                                salesChannelRegister.set('currency', response.currency.toLowerCase());
                            }
                            if (response.from_email) {
                                salesChannelRegister.set('email', response.from_email);
                            }
                            if(response.campaign_duration){
                                salesChannelRegister.set('durations', JSON.stringify(response.campaign_duration));
                            }
                            if(response.default_campaign_duration) {
                                salesChannelRegister.set('default_duration', response.default_campaign_duration);
                            }
                            if (response.ga_id && dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                                ReactGA.initialize(response.ga_id);
                                salesChannelRegister.set('ga_id', response.ga_id);
                            }
                            if (response.ga4_id && dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                                ReactGA4.initialize(response.ga4_id);
                                salesChannelRegister.set('ga4_id', response.ga4_id);
                            }
                            if (response.fb_id && dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                                ReactPixel.init(response.fb_id);
                                salesChannelRegister.set('fb_id', response.fb_id);
                            }
                            if (response.vat) {
                                salesChannelRegister.set('vat', response.vat);
                            }else{
                                salesChannelRegister.set('vat', 0);
                            }
                            if (response.socialData) {
                                if (response.socialData.image && response.socialData.title !== "") {
                                    salesChannelRegister.set('socialIcon', response.socialData.image);
                                }
                                if (response.socialData.title && response.socialData.title !== "") {
                                    salesChannelRegister.set('socialTitle', response.socialData.title);
                                }
                                if (response.socialData.facebookID && response.socialData.facebookID !== "") {
                                    salesChannelRegister.set('facebookId', response.socialData.facebookID);
                                }
                                if (response.socialData.instagramID && response.socialData.instagramID !== "") {
                                    salesChannelRegister.set('instagramId', response.socialData.instagramID);
                                }
                            }

                            if (response.keyword_languages) {
                                salesChannelRegister.set('keyword_languages', JSON.stringify(response.keyword_languages));
                            }

                            //TEMP -> REMOVE LATER
                            if(this.props.match.params.market === "se") {
                                salesChannelRegister.set('ad_languages', JSON.stringify([{value: "sv", title: {en:"Swedish", sv:"Svenska"}}]));
                                salesChannelRegister.set('default_ad_language', "sv");
                            }else if(this.props.match.params.market === "ae"){
                                salesChannelRegister.set('ad_languages', JSON.stringify([{value: "en", title: {en:"English"}}]));
                                salesChannelRegister.set('default_ad_language', "en");
                            }

                            //TEMP -> REMOVE LATER
                            if(this.props.match.params.market === "se") {
                                salesChannelRegister.set('languages', JSON.stringify([{code: "sv", name: "Svenska", names: {sv: "Svenska", en: "Svenska"}}, {code: "en", name: "Engelska", names: {sv: "English", en: "English"}}]));
                            }else if(this.props.match.params.market === "ae"){
                                salesChannelRegister.set('languages', JSON.stringify([{code: "en", name: "English", names: {en: "English"}}]));
                            }

                            this._checkPrivate();

                        }
                    });

                }else{

                    //GO TO SELECT LANGUAGE
                    sessionStorage.clear();
                    this.props.history.replace("/" + this.props.match.params.market + "/" + markets[this.props.match.params.market].default + "/" + this.props.match.params.saleschannel);
                    window.location.reload();

                }

            } else {
                this.setState({error: true, isLoading: false});
            }
        } catch (e) {
            this.setState({error: true, isLoading: false});
        }
    }

    async _updateData() {
        if (this.props.match.params.saleschannel) {
            if (salesChannelRegister.get('name') !== this.props.match.params.saleschannel || salesChannelRegister.get('market') !== this.props.match.params.market) {

                cartRegister.remove();
                quotesRegister.remove();
                imagesRegister.remove();
                tokenRegister.remove();
                userRegister.remove();
                salesChannelRegister.remove('socialIcon');
                salesChannelRegister.remove('socialTitle');
                salesChannelRegister.remove('facebookId');
                salesChannelRegister.remove('instagramId');
                salesChannelRegister.remove('private');

                try {
                    let data = await dataRegister.getSalesChannelData(this.props.match.params.market, this.props.match.params.saleschannel);
                    return data;
                } catch (e) {
                    this.setState({error: true, isLoading: false});
                }

            } else {
                if (salesChannelRegister.get('ga_id') && dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                    ReactGA.initialize(salesChannelRegister.get('ga_id'));
                }
                if (salesChannelRegister.get('ga4_id') && dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                    ReactGA4.initialize(salesChannelRegister.get('ga4_id'));
                }
                if (salesChannelRegister.get('fb_id') && dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                    ReactPixel.init(salesChannelRegister.get('fb_id'));
                }
                this._updateTitle(salesChannelRegister.get('company_name'));
                this.setState({error: false, isLoading: false});
                this._checkPrivate();
            }
        } else {
            this.setState({error: true, isLoading: false});
        }
    }

    _checkPrivate(){
        if(salesChannelRegister.get("private")){
            if(!tokenRegister.getToken() &&
                (window.location.href.toLowerCase().indexOf("login") === -1 &&
                    window.location.href.toLowerCase().indexOf("forgot-password") === -1 &&
                    window.location.href.toLowerCase().indexOf("changepassword") === -1 &&
                    window.location.href.toLowerCase().indexOf("register") === -1 &&

                    //REMOVE REGISTER
                    //window.location.href.toLowerCase().indexOf("register") === -1 &&
                    //

                    window.location.href.toLowerCase().indexOf("token") === -1
                )){
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/login");
            }else{
                this.setState({error: false, isLoading: false});
            }
        }else{
            this.setState({error: false, isLoading: false});
        }
    }

    _updateTitle(name) {
        document.title = name + " | " + this._renderText("item_1");
    }

    _renderRoute(route){
        if(salesChannelRegister.get("private")){
            if(tokenRegister.getToken()){
                return route;
            }
        }else{
            return route;
        }
    }

    _renderText(item) {
        return langRegister.get("router-wrapper", item);
    }

    render() {
        return (
            <div>
                {
                    salesChannelRegister.get('name') !== 'adbop' &&
                    <Helmet>
                        <link rel="apple-touch-icon" sizes="120x120" href={SCfaviconAppleTouch}/>
                        <link rel="icon" type="image/png" sizes="32x32" href={SCfavicon32}/>
                        <link rel="icon" type="image/png" sizes="16x16" href={SCfavicon16}/>
                        <link rel="manifest" href={SCfaviconSiteManifest}/>
                        <link rel="mask-icon" href={SCfaviconSiteSafari} color="#000000"/>
                        <meta name="msapplication-TileColor" content="#41CBC7"/>
                        <meta name="theme-color" content="#FFFFFF"/>
                        <meta name="description" content="The customizable self-service solution for inhouse teams looking for instant performance, simply launch agency grade campaigns in minutes and enjoy close to zero admin – pay only for performance. Leverage AI driven multi-channel advertising across Google, Facebook, Instagram, Bing and many more"/>
                    </Helmet>
                }
                {
                    salesChannelRegister.get('name') === 'adbop' &&
                    <Helmet>
                        <link rel="apple-touch-icon" sizes="180x180" href={ABfaviconAppleTouch}/>
                        <link rel="icon" type="image/png" sizes="32x32" href={ABfavicon32}/>
                        <link rel="icon" type="image/png" sizes="16x16" href={ABfavicon16}/>
                        <link rel="manifest" href={ABfaviconSiteManifest}/>
                        <link rel="mask-icon" href={ABfaviconSiteSafari} color="#000000"/>
                        <meta name="msapplication-TileColor" content="#41CBC7"/>
                        <meta name="theme-color" content="#FFFFFF"/>
                        <meta name="description" content="adBop is a one-stop-shop for online advertisers with little or no prior marketing skills looking for instant performance, simply launch agency grade campaigns in minutes and enjoy close to zero admin – pay only for performance. Leverage AI driven multi-channel advertising across Google, Facebook, Instagram, Bing and many more"/>
                    </Helmet>
                }

                {

                    !this.state.isLoading && !this.state.error &&
                        <Switch>

                            {
                                this._renderRoute(<Route exact path={this.props.match.url} component={SignupHome}/>)
                            }

                            <Route exact path={this.props.match.url + '/signup/home'} component={SignupHome}/>
                            <Route exact path={this.props.match.url + '/signup/industry'} component={SignupIndustry}/>
                            <Route exact path={this.props.match.url + '/signup/crossroad'} component={SignupCrossroad}/>
                            <Route exact path={this.props.match.url + '/signup/image'} component={SignupImage}/>
                            <Route exact path={this.props.match.url + '/signup/video'} component={SignupVideo}/>
                            <Route exact path={this.props.match.url + '/signup/slideshow'} component={SignupSlideshow}/>
                            <Route exact path={this.props.match.url + '/signup/quotes'} component={SignupQuotesDivided}/>
                            <Route exact path={this.props.match.url + '/signup/quotes-custom'} component={SignupQuotes}/>
                            <Route exact path={this.props.match.url + '/signup/business'} component={SignupBusiness}/>
                            <Route exact path={this.props.match.url + '/signup/theme'} component={SignUpTheme}/>
                            <Route exact path={this.props.match.url + '/signup/theme-custom'} component={SignUpThemeCustom}/>
                            <Route exact path={this.props.match.url + '/signup/ads'} component={SignupAds}/>
                            <Route exact path={this.props.match.url + '/signup/filter'} component={SignupFilter}/>
                            <Route exact path={this.props.match.url + '/signup/budget'} component={SignupBudget}/>
                            <Route exact path={this.props.match.url + '/signup/checkout'} component={SignupCheckout}/>
                            <Route exact path={this.props.match.url + '/signup/payment'} component={SignupPayment}/>
                            <Route exact path={this.props.match.url + '/signup/confirmation'} component={SignupConfirmation}/>
                            <Route exact path={this.props.match.url + '/register'} component={Register}/>
                            <Route path={this.props.match.url + '/user'} component={User}/>

                            <Route exact path={this.props.match.url + '/token/:hash'} component={Token}/>
                            <Route exact path={this.props.match.url + '/login'} component={LoginNopin}/>
                            <Route exact path={this.props.match.url + '/redirect'} component={SignupPaymentRedirect}/>
                            <Route exact path={this.props.match.url + '/forgot-password'} component={ForgotPassword}/>
                            <Route exact path={this.props.match.url + '/forgot-password/:email'} component={ForgotPassword}/>
                            <Route exact path={this.props.match.url + '/changepassword/:code'} component={ResetPassword}/>
                        </Switch>
                }
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler/>
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                    </div>
                }
            </div>
        );
    }

}

export default RouterWrapper


// WEBPACK FOOTER //
// ./src/components/router-wrapper/component.js